var _path, _path2, _path3, _path4, _path5, _path6, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRain(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48.8014 46.9032H25.1858C20.6869 46.9032 16.3723 45.116 13.1911 41.9348C10.0098 38.7536 8.22266 34.439 8.22266 29.94C8.22266 25.4411 10.0098 21.1265 13.1911 17.9453C16.3723 14.7641 20.6869 12.9769 25.1858 12.9769C26.095 12.9765 27.0027 13.0487 27.9003 13.193C29.6057 9.76716 32.1247 6.81144 35.2368 4.58443C39.2101 1.74104 43.9007 0.238159 48.8014 0.238159C54.1844 0.240936 59.4009 2.10449 63.5672 5.51311C67.7335 8.92173 70.5934 13.6658 71.6623 18.9416C72.7312 24.2174 71.9435 29.7005 69.4325 34.462C66.9215 39.2235 62.8418 42.9706 57.8844 45.0684C55.011 46.2849 51.9216 46.909 48.8014 46.9032Z",
    fill: "url(#paint0_linear_839_368)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.2834 73.3564C21.4032 72.2707 21.1787 69.6442 22.848 68.2556L27.3873 64.4776C27.5354 64.3541 27.7179 64.279 27.9101 64.2626C28.1023 64.2461 28.2949 64.2891 28.4619 64.3857C28.6288 64.482 28.7622 64.6273 28.844 64.8018C28.9257 64.9763 28.952 65.1717 28.9192 65.3616L27.9182 71.1825C27.5492 73.323 25.1624 74.4418 23.2834 73.3564Z",
    fill: "url(#paint1_linear_839_368)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M45.0244 73.3564C43.1442 72.2707 42.9202 69.6442 44.589 68.2556L49.1295 64.4776C49.2776 64.3541 49.4602 64.279 49.6523 64.2626C49.8445 64.2461 50.0372 64.2891 50.2041 64.3857C50.371 64.4821 50.5044 64.6273 50.5862 64.8018C50.668 64.9763 50.6944 65.1717 50.6618 65.3616L49.6604 71.1825C49.2915 73.323 46.905 74.4418 45.0244 73.3564Z",
    fill: "url(#paint2_linear_839_368)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4113 60.9183C10.5311 59.8325 10.3066 57.206 11.9759 55.8174L16.5176 52.0399C16.6658 51.9165 16.8483 51.8415 17.0405 51.8252C17.2327 51.8088 17.4252 51.8518 17.5922 51.9483C17.7591 52.0447 17.8925 52.1899 17.9743 52.3644C18.0562 52.5389 18.0826 52.7343 18.0499 52.9242L17.0465 58.7463C16.6768 60.8848 14.2919 62.004 12.4113 60.9183Z",
    fill: "url(#paint3_linear_839_368)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M34.1535 60.9182C32.2729 59.8324 32.0489 57.2059 33.7157 55.8173L38.2562 52.0398C38.4045 51.9164 38.587 51.8415 38.7792 51.8252C38.9713 51.8088 39.1639 51.8518 39.3308 51.9482C39.4977 52.0447 39.6309 52.1899 39.7127 52.3644C39.7944 52.5389 39.8208 52.7342 39.7882 52.9241L38.7884 58.7462C38.4206 60.8847 36.0337 62.0039 34.1535 60.9182Z",
    fill: "url(#paint4_linear_839_368)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M55.8957 60.9183C54.0155 59.8325 53.791 57.206 55.4603 55.8174L60.0008 52.0399C60.149 51.9165 60.3315 51.8415 60.5237 51.8252C60.7159 51.8088 60.9084 51.8518 61.0754 51.9483C61.2423 52.0447 61.3757 52.1899 61.4575 52.3644C61.5394 52.5389 61.5657 52.7343 61.5331 52.9242L60.5309 58.7463C60.1627 60.8848 57.7759 62.004 55.8957 60.9183Z",
    fill: "url(#paint5_linear_839_368)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_839_368",
    x1: 4.87698,
    y1: 60.4845,
    x2: 70.2278,
    y2: 0.639346,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#69BBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9DE0F4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_839_368",
    x1: 51.033,
    y1: 29.2896,
    x2: 20.871,
    y2: 76.9262,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#69BBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1798FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_839_368",
    x1: 66.5536,
    y1: 39.1164,
    x2: 36.3916,
    y2: 86.7531,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#69BBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1798FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_839_368",
    x1: 37.6519,
    y1: 20.8164,
    x2: 7.48992,
    y2: 68.4534,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#69BBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1798FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_839_368",
    x1: 53.1716,
    y1: 30.6432,
    x2: 23.0097,
    y2: 78.2802,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#69BBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1798FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_839_368",
    x1: 68.6921,
    y1: 40.4705,
    x2: 38.5301,
    y2: 88.1071,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#69BBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1798FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRain);
export default __webpack_public_path__ + "static/media/RAIN.1bfc1c5a3f998ea391d59e0dfb2db768.svg";
export { ForwardRef as ReactComponent };